import React, {Component} from 'react';
import Page from '../../components/Page';
import './styles.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import BigCalendar from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import {getCalendarHolidays, getCalendarVacations} from '../../actions/calendar';
import _ from 'lodash';

moment.locale('en-us',{
    week: {
        dow: 1,
        doy: 1,
    },
});
BigCalendar.setLocalizer(
    BigCalendar.momentLocalizer(moment)
);

const formats = {
   weekdayFormat: 'dd'
};

//
// const events = [
//     {
//         'title': 'All Day Event',
//         'allDay': true,
//         'start': new Date(2015, 3, 0),
//         'end': new Date(2015, 3, 0)
//     },
//     {
//         'title': 'Long Event',
//         'start': new Date(2015, 3, 7),
//         'end': new Date(2015, 3, 10)
//     }
// ];

class Calendar extends Component {

    componentWillMount() {
        this.props.dispatch(getCalendarHolidays());
        this.props.dispatch(getCalendarVacations());
    }


    eventStyleGetter(event, start, end, isSelected) {
        var backgroundColor = event.hexColor;
        var style = {
            backgroundColor: backgroundColor,
            // borderRadius: '0px',
            // opacity: 0.8,
            // color: 'black',
            // border: '0px',
            // display: 'block'
        };
        return {
            style: style
        };
    }

    render() {
        let events = [];

        this.props.vacations.forEach(vacation => {
            if (['open', 'approved'].indexOf(vacation.status) === -1) {
                return;
            }
            let title = vacation.title || 'Vacation';

            let user = _.find(this.props.users, {_id: vacation.userId});
            let color = (user && user.color) || '#38CDBE';

            events.push({
                title: title,
                start: new Date(vacation.startAt),
                end: new Date(vacation.endAt),
                hexColor: color,
            });
        });

        this.props.holidays.forEach(holiday => {
            let year = holiday.year || moment().year();
            if (year !== moment().year()) {
                return;
            }
            events.push({
                title: holiday.name,
                start: new Date(year, holiday.month-1, holiday.day),
                end: new Date(year, holiday.month-1, holiday.day),
                hexColor: '#F61C33',
            });
        });

        return (
            <Page {...this.props} >
                <div className="col-xs-12">
                    <div className="Card">
                        <div className="Cal-Legend">
                            <span><span className="dot" style={{background: '#F61C33'}} /> Holiday</span>
                            <span><span className="dot" style={{background: '#0d9488'}} /> Vacation</span>
                        </div>
                        <div className="Calendar">
                            <BigCalendar
                                {...this.props}
                                eventPropGetter={this.eventStyleGetter}
                                events={events}
                                formats={formats}
                                views={[BigCalendar.Views.MONTH]}
                                step={60}
                                defaultDate={new Date()}
                            />
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
}
Calendar.propTypes = {
    vacations: PropTypes.arrayOf(PropTypes.object),
    holidays: PropTypes.arrayOf(PropTypes.object),
    users: PropTypes.arrayOf(PropTypes.object),

};

Calendar.defaultProps = {
    vacations: [],
    holidays: [],
    users: [],
};


function mapStateToProps(state) {
    const vacations = state.calendar.vacations;
    const holidays = state.calendar.holidays;
    const users = state.users;

    return {
        vacations: vacations,
        holidays: holidays,
        users: users,
    };
}

export default connect(mapStateToProps)(Calendar);


// WEBPACK FOOTER //
// ./src/screens/Calendar/index.js